import script from "./CadastroNoticia.vue?vue&type=script&setup=true&lang=js"
export * from "./CadastroNoticia.vue?vue&type=script&setup=true&lang=js"

import "./CadastroNoticia.vue?vue&type=style&index=0&id=48601a08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48601a08"]])

export default __exports__